import { render, staticRenderFns } from "./ChatUploadMedia.vue?vue&type=template&id=6550a2b2&scoped=true&"
import script from "./ChatUploadMedia.vue?vue&type=script&lang=js&"
export * from "./ChatUploadMedia.vue?vue&type=script&lang=js&"
import style0 from "./ChatUploadMedia.vue?vue&type=style&index=0&id=6550a2b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6550a2b2",
  null
  
)

export default component.exports